import { defineMessages } from './define'

/* Report charts and tables (rp.*), and booking by serial (srl.*). */

export default defineMessages({
  en: {
    'rp.overview': 'Overview',
    'rp.doctors': 'Doctors',
    'rp.doctor': 'Doctor',
    'rp.wholeClinic': 'Whole clinic',
    'rp.myPatients': 'My patients',
    'rp.visitsPerDay': 'Visits per day',
    'rp.collectedPerDay': 'Collected per day',
    'rp.categorySplit': 'Diabetic and Non-Diabetic',
    'rp.visitsWord': 'visits',
    'rp.notSet': 'Not set',
    'rp.dayByDay': 'Day by day',
    'rp.date': 'Date',
    'rp.total': 'Total',
    'rp.perVisit': 'Per visit',
    'rp.consults': 'Seen',
    'rp.waitMin': 'Wait min',
    'rp.consultMin': 'Consult min',
    'rp.practiceNote': 'Ranked by how often each was recorded in the period.',
    'rp.diagnosis': 'Diagnosis',
    'rp.test': 'Test',
    'rp.medicine': 'Medicine',
    'rp.count': 'Count',
    'rp.share': 'Share',
    'rp.billed': 'Billed',
    'rp.due': 'Due',
    'rp.category': 'Category',
    'rp.item': 'Item',
    'rp.itemsN': '{n} items',
    'rp.others': '{n} others',
    'rp.onHand': 'On hand',
    'rp.reorderAt': 'Reorder at',
    'rp.used': 'Used',
    'rp.received': 'Received',
    'rp.cost': 'Cost',
    'rp.usedPerDay': 'Stock used per day (at cost)',
    'rp.testsPerDay': 'Tests done per day',
    'rp.testsN': '{n} tests',
    'rp.incomeSplit': 'Income by test',
    'rp.byTest': 'By test',
    'rp.income': 'Income',
    'rp.stockCost': 'Stock',
    'rp.margin': 'Margin',
    'rp.inStock': 'In stock',
    'rp.stockHealthAria': '{ok} in stock, {low} low, {out} out',
    'rp.view': 'View',
    'rp.viewList': 'List',
    'rp.viewTable': 'Table',

    'srl.bookingRules': 'Bookings',
    'srl.apptTimeRequired': 'Doctor bookings need a time',
    'srl.apptTimeOnNote': 'On: the patient picks an exact time slot.',
    'srl.apptTimeOffNote': 'Off: book by serial number in a session. Picking an exact time stays optional.',
    'srl.labTimeRequired': 'Lab tests need a time',
    'srl.labTimeOnNote': 'On: every test is booked for a collection time.',
    'srl.labTimeOffNote': 'Off: a test can be booked for any time that day, and is numbered by serial.',
    'srl.appointmentsOn': 'Appointments',
    'srl.appointmentsOnNote': 'On: patients and the desk can book doctor visits ahead of time.',
    'srl.appointmentsOffNote': 'Off: the clinic runs on billing alone. Booking screens are hidden.',
    'srl.nextSerial': 'Next serial',
    'srl.placesLeft': '{n} places left',
    'srl.pickExact': 'Choose an exact time instead',
    'srl.useSerial': 'Book by serial number instead',
    'srl.pickSession': 'Pick a session',
    'srl.serial': 'Serial',
    'srl.serialN': 'Serial #{n}',
    'srl.whenSerial': '{date} · {session} · Serial #{n}',
    'srl.around': 'around {time}',
    'srl.anyTime': 'Any time',
    'srl.anyShort': 'Any',
    'srl.labAnyTime': 'Any time that day',
    'srl.labPickTime': 'Pick a time',
    'srl.labAnyTimeNote': 'Booked for {date}, any time. The lab takes samples in serial order.',
    'srl.labAnyTimeOn': '{date}, any time',
    'srl.labBookDay': 'Book for {date}',
  },
  hi: {
    'rp.overview': 'सारांश',
    'rp.doctors': 'डॉक्टर',
    'rp.doctor': 'डॉक्टर',
    'rp.wholeClinic': 'पूरा क्लिनिक',
    'rp.myPatients': 'मेरे मरीज़',
    'rp.visitsPerDay': 'प्रतिदिन विज़िट',
    'rp.collectedPerDay': 'प्रतिदिन वसूली',
    'rp.categorySplit': 'डायबिटिक और नॉन-डायबिटिक',
    'rp.visitsWord': 'विज़िट',
    'rp.notSet': 'तय नहीं',
    'rp.dayByDay': 'दिन-ब-दिन',
    'rp.date': 'तारीख',
    'rp.total': 'कुल',
    'rp.perVisit': 'प्रति विज़िट',
    'rp.consults': 'देखे गए',
    'rp.waitMin': 'इंतज़ार मिनट',
    'rp.consultMin': 'परामर्श मिनट',
    'rp.practiceNote': 'इस अवधि में कितनी बार दर्ज हुआ, उसी क्रम में।',
    'rp.diagnosis': 'निदान',
    'rp.test': 'जाँच',
    'rp.medicine': 'दवा',
    'rp.count': 'संख्या',
    'rp.share': 'हिस्सा',
    'rp.billed': 'बिल',
    'rp.due': 'बकाया',
    'rp.category': 'श्रेणी',
    'rp.item': 'सामान',
    'rp.itemsN': '{n} सामान',
    'rp.others': '{n} अन्य',
    'rp.onHand': 'मौजूद',
    'rp.reorderAt': 'दोबारा मँगाएँ',
    'rp.used': 'इस्तेमाल',
    'rp.received': 'आया',
    'rp.cost': 'लागत',
    'rp.usedPerDay': 'प्रतिदिन इस्तेमाल स्टॉक (लागत पर)',
    'rp.testsPerDay': 'प्रतिदिन हुई जाँचें',
    'rp.testsN': '{n} जाँचें',
    'rp.incomeSplit': 'जाँच के अनुसार आय',
    'rp.byTest': 'जाँच के अनुसार',
    'rp.income': 'आय',
    'rp.stockCost': 'स्टॉक',
    'rp.margin': 'मार्जिन',
    'rp.inStock': 'स्टॉक में',
    'rp.stockHealthAria': '{ok} स्टॉक में, {low} कम, {out} ख़त्म',
    'rp.view': 'दृश्य',
    'rp.viewList': 'सूची',
    'rp.viewTable': 'तालिका',

    'srl.bookingRules': 'बुकिंग',
    'srl.apptTimeRequired': 'डॉक्टर बुकिंग में समय ज़रूरी',
    'srl.apptTimeOnNote': 'चालू: मरीज़ सही समय चुनता है।',
    'srl.apptTimeOffNote': 'बंद: सत्र में सीरियल नंबर से बुकिंग। सही समय चुनना वैकल्पिक रहता है।',
    'srl.labTimeRequired': 'लैब जाँच में समय ज़रूरी',
    'srl.labTimeOnNote': 'चालू: हर जाँच सैंपल के समय के साथ बुक होती है।',
    'srl.labTimeOffNote': 'बंद: जाँच उस दिन किसी भी समय के लिए बुक हो सकती है, सीरियल नंबर से।',
    'srl.appointmentsOn': 'अपॉइंटमेंट',
    'srl.appointmentsOnNote': 'चालू: मरीज़ और रिसेप्शन पहले से डॉक्टर की अपॉइंटमेंट बुक कर सकते हैं।',
    'srl.appointmentsOffNote': 'बंद: क्लिनिक सिर्फ़ बिलिंग से चलता है। बुकिंग स्क्रीन छिपी रहती हैं।',
    'srl.nextSerial': 'अगला सीरियल',
    'srl.placesLeft': '{n} जगह बाकी',
    'srl.pickExact': 'इसके बजाय सही समय चुनें',
    'srl.useSerial': 'इसके बजाय सीरियल नंबर से बुक करें',
    'srl.pickSession': 'सत्र चुनें',
    'srl.serial': 'सीरियल',
    'srl.serialN': 'सीरियल #{n}',
    'srl.whenSerial': '{date} · {session} · सीरियल #{n}',
    'srl.around': 'लगभग {time}',
    'srl.anyTime': 'कभी भी',
    'srl.anyShort': 'कभी भी',
    'srl.labAnyTime': 'उस दिन कभी भी',
    'srl.labPickTime': 'समय चुनें',
    'srl.labAnyTimeNote': '{date} के लिए, कभी भी। लैब सीरियल क्रम में सैंपल लेती है।',
    'srl.labAnyTimeOn': '{date}, कभी भी',
    'srl.labBookDay': '{date} के लिए बुक करें',
  },
  mr: {
    'rp.overview': 'सारांश',
    'rp.doctors': 'डॉक्टर',
    'rp.doctor': 'डॉक्टर',
    'rp.wholeClinic': 'संपूर्ण क्लिनिक',
    'rp.myPatients': 'माझे रुग्ण',
    'rp.visitsPerDay': 'दररोज भेटी',
    'rp.collectedPerDay': 'दररोज वसुली',
    'rp.categorySplit': 'डायबेटिक आणि नॉन-डायबेटिक',
    'rp.visitsWord': 'भेटी',
    'rp.notSet': 'ठरलेले नाही',
    'rp.dayByDay': 'दिवसानुसार',
    'rp.date': 'तारीख',
    'rp.total': 'एकूण',
    'rp.perVisit': 'प्रति भेट',
    'rp.consults': 'तपासले',
    'rp.waitMin': 'प्रतीक्षा मिनिटे',
    'rp.consultMin': 'तपासणी मिनिटे',
    'rp.practiceNote': 'या कालावधीत किती वेळा नोंदले गेले, त्या क्रमाने.',
    'rp.diagnosis': 'निदान',
    'rp.test': 'चाचणी',
    'rp.medicine': 'औषध',
    'rp.count': 'संख्या',
    'rp.share': 'वाटा',
    'rp.billed': 'बिल',
    'rp.due': 'थकबाकी',
    'rp.category': 'वर्ग',
    'rp.item': 'वस्तू',
    'rp.itemsN': '{n} वस्तू',
    'rp.others': 'इतर {n}',
    'rp.onHand': 'उपलब्ध',
    'rp.reorderAt': 'पुन्हा मागवा',
    'rp.used': 'वापर',
    'rp.received': 'आले',
    'rp.cost': 'खर्च',
    'rp.usedPerDay': 'दररोज वापरलेला स्टॉक (किमतीवर)',
    'rp.testsPerDay': 'दररोज झालेल्या चाचण्या',
    'rp.testsN': '{n} चाचण्या',
    'rp.incomeSplit': 'चाचणीनुसार उत्पन्न',
    'rp.byTest': 'चाचणीनुसार',
    'rp.income': 'उत्पन्न',
    'rp.stockCost': 'स्टॉक',
    'rp.margin': 'नफा',
    'rp.inStock': 'स्टॉकमध्ये',
    'rp.stockHealthAria': '{ok} स्टॉकमध्ये, {low} कमी, {out} संपले',
    'rp.view': 'दृश्य',
    'rp.viewList': 'यादी',
    'rp.viewTable': 'तक्ता',

    'srl.bookingRules': 'बुकिंग',
    'srl.apptTimeRequired': 'डॉक्टर बुकिंगसाठी वेळ आवश्यक',
    'srl.apptTimeOnNote': 'चालू: रुग्ण नेमकी वेळ निवडतो.',
    'srl.apptTimeOffNote': 'बंद: सत्रात सिरीयल नंबरने बुकिंग. नेमकी वेळ निवडणे ऐच्छिक राहते.',
    'srl.labTimeRequired': 'लॅब चाचणीसाठी वेळ आवश्यक',
    'srl.labTimeOnNote': 'चालू: प्रत्येक चाचणी नमुन्याच्या वेळेसह बुक होते.',
    'srl.labTimeOffNote': 'बंद: चाचणी त्या दिवशी कधीही बुक करता येते, सिरीयल नंबरने.',
    'srl.appointmentsOn': 'अपॉइंटमेंट',
    'srl.appointmentsOnNote': 'चालू: रुग्ण आणि रिसेप्शन आधीच डॉक्टरची अपॉइंटमेंट बुक करू शकतात.',
    'srl.appointmentsOffNote': 'बंद: क्लिनिक फक्त बिलिंगवर चालते. बुकिंग स्क्रीन लपलेल्या राहतात.',
    'srl.nextSerial': 'पुढील सिरीयल',
    'srl.placesLeft': '{n} जागा शिल्लक',
    'srl.pickExact': 'त्याऐवजी नेमकी वेळ निवडा',
    'srl.useSerial': 'त्याऐवजी सिरीयल नंबरने बुक करा',
    'srl.pickSession': 'सत्र निवडा',
    'srl.serial': 'सिरीयल',
    'srl.serialN': 'सिरीयल #{n}',
    'srl.whenSerial': '{date} · {session} · सिरीयल #{n}',
    'srl.around': 'सुमारे {time}',
    'srl.anyTime': 'कधीही',
    'srl.anyShort': 'कधीही',
    'srl.labAnyTime': 'त्या दिवशी कधीही',
    'srl.labPickTime': 'वेळ निवडा',
    'srl.labAnyTimeNote': '{date} साठी, कधीही. लॅब सिरीयल क्रमाने नमुने घेते.',
    'srl.labAnyTimeOn': '{date}, कधीही',
    'srl.labBookDay': '{date} साठी बुक करा',
  },
  or: {
    'rp.overview': 'ସାରାଂଶ',
    'rp.doctors': 'ଡାକ୍ତର',
    'rp.doctor': 'ଡାକ୍ତର',
    'rp.wholeClinic': 'ସମଗ୍ର କ୍ଲିନିକ',
    'rp.myPatients': 'ମୋ ରୋଗୀ',
    'rp.visitsPerDay': 'ଦିନପ୍ରତି ଭିଜିଟ',
    'rp.collectedPerDay': 'ଦିନପ୍ରତି ଆଦାୟ',
    'rp.categorySplit': 'ଡାଏବେଟିକ ଓ ନନ-ଡାଏବେଟିକ',
    'rp.visitsWord': 'ଭିଜିଟ',
    'rp.notSet': 'ସ୍ଥିର ନାହିଁ',
    'rp.dayByDay': 'ଦିନ ଅନୁସାରେ',
    'rp.date': 'ତାରିଖ',
    'rp.total': 'ମୋଟ',
    'rp.perVisit': 'ଭିଜିଟ ପ୍ରତି',
    'rp.consults': 'ଦେଖାଗଲା',
    'rp.waitMin': 'ଅପେକ୍ଷା ମିନିଟ',
    'rp.consultMin': 'ପରାମର୍ଶ ମିନିଟ',
    'rp.practiceNote': 'ଏହି ଅବଧିରେ କେତେଥର ଲେଖାଗଲା, ସେହି କ୍ରମରେ।',
    'rp.diagnosis': 'ରୋଗ ନିର୍ଣ୍ଣୟ',
    'rp.test': 'ପରୀକ୍ଷା',
    'rp.medicine': 'ଔଷଧ',
    'rp.count': 'ସଂଖ୍ୟା',
    'rp.share': 'ଅଂଶ',
    'rp.billed': 'ବିଲ',
    'rp.due': 'ବାକି',
    'rp.category': 'ବର୍ଗ',
    'rp.item': 'ସାମଗ୍ରୀ',
    'rp.itemsN': '{n} ସାମଗ୍ରୀ',
    'rp.others': 'ଅନ୍ୟ {n}',
    'rp.onHand': 'ଉପଲବ୍ଧ',
    'rp.reorderAt': 'ପୁଣି ମଗାନ୍ତୁ',
    'rp.used': 'ବ୍ୟବହୃତ',
    'rp.received': 'ଆସିଲା',
    'rp.cost': 'ଖର୍ଚ୍ଚ',
    'rp.usedPerDay': 'ଦିନପ୍ରତି ବ୍ୟବହୃତ ଷ୍ଟକ (ମୂଲ୍ୟରେ)',
    'rp.testsPerDay': 'ଦିନପ୍ରତି ହୋଇଥିବା ପରୀକ୍ଷା',
    'rp.testsN': '{n} ପରୀକ୍ଷା',
    'rp.incomeSplit': 'ପରୀକ୍ଷା ଅନୁସାରେ ଆୟ',
    'rp.byTest': 'ପରୀକ୍ଷା ଅନୁସାରେ',
    'rp.income': 'ଆୟ',
    'rp.stockCost': 'ଷ୍ଟକ',
    'rp.margin': 'ଲାଭ',
    'rp.inStock': 'ଷ୍ଟକରେ',
    'rp.stockHealthAria': '{ok} ଷ୍ଟକରେ, {low} କମ, {out} ସରିଗଲା',
    'rp.view': 'ଦୃଶ୍ୟ',
    'rp.viewList': 'ତାଲିକା',
    'rp.viewTable': 'ସାରଣୀ',

    'srl.bookingRules': 'ବୁକିଂ',
    'srl.apptTimeRequired': 'ଡାକ୍ତର ବୁକିଂରେ ସମୟ ଆବଶ୍ୟକ',
    'srl.apptTimeOnNote': 'ଚାଲୁ: ରୋଗୀ ଠିକ ସମୟ ବାଛନ୍ତି।',
    'srl.apptTimeOffNote': 'ବନ୍ଦ: ସେସନରେ ସିରିଆଲ ନମ୍ବରରେ ବୁକିଂ। ଠିକ ସମୟ ବାଛିବା ଇଚ୍ଛାଧୀନ ରହେ।',
    'srl.labTimeRequired': 'ଲ୍ୟାବ ପରୀକ୍ଷାରେ ସମୟ ଆବଶ୍ୟକ',
    'srl.labTimeOnNote': 'ଚାଲୁ: ପ୍ରତ୍ୟେକ ପରୀକ୍ଷା ନମୁନା ସମୟ ସହ ବୁକ ହୁଏ।',
    'srl.labTimeOffNote': 'ବନ୍ଦ: ପରୀକ୍ଷା ସେହି ଦିନ ଯେକୌଣସି ସମୟ ପାଇଁ ବୁକ ହୋଇପାରେ, ସିରିଆଲ ନମ୍ବରରେ।',
    'srl.appointmentsOn': 'ଆପଏଣ୍ଟମେଣ୍ଟ',
    'srl.appointmentsOnNote': 'ଚାଲୁ: ରୋଗୀ ଓ ରିସେପ୍ସନ ଆଗରୁ ଡାକ୍ତରଙ୍କ ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ କରିପାରିବେ।',
    'srl.appointmentsOffNote': 'ବନ୍ଦ: କ୍ଲିନିକ କେବଳ ବିଲିଂରେ ଚାଲେ। ବୁକିଂ ସ୍କ୍ରିନ ଲୁଚି ରହେ।',
    'srl.nextSerial': 'ପରବର୍ତ୍ତୀ ସିରିଆଲ',
    'srl.placesLeft': '{n} ସ୍ଥାନ ବାକି',
    'srl.pickExact': 'ଏହା ବଦଳରେ ଠିକ ସମୟ ବାଛନ୍ତୁ',
    'srl.useSerial': 'ଏହା ବଦଳରେ ସିରିଆଲ ନମ୍ବରରେ ବୁକ କରନ୍ତୁ',
    'srl.pickSession': 'ସେସନ ବାଛନ୍ତୁ',
    'srl.serial': 'ସିରିଆଲ',
    'srl.serialN': 'ସିରିଆଲ #{n}',
    'srl.whenSerial': '{date} · {session} · ସିରିଆଲ #{n}',
    'srl.around': 'ପ୍ରାୟ {time}',
    'srl.anyTime': 'ଯେକୌଣସି ସମୟ',
    'srl.anyShort': 'ଯେକୌଣସି',
    'srl.labAnyTime': 'ସେହି ଦିନ ଯେକୌଣସି ସମୟ',
    'srl.labPickTime': 'ସମୟ ବାଛନ୍ତୁ',
    'srl.labAnyTimeNote': '{date} ପାଇଁ, ଯେକୌଣସି ସମୟ। ଲ୍ୟାବ ସିରିଆଲ କ୍ରମରେ ନମୁନା ନିଏ।',
    'srl.labAnyTimeOn': '{date}, ଯେକୌଣସି ସମୟ',
    'srl.labBookDay': '{date} ପାଇଁ ବୁକ କରନ୍ତୁ',
  },
})
